const routes = [
  {
    path: "/gestor/formulario-trabalho/atividades/lista-atividades",
    component: () => import("@/views/gestor/atividades/ListaAtividades.vue"),
    meta: {
      menu: "dashboard",
      title: "Atividades",
      componente: "vueGestorFormulariosTrabalhoNovoJob",
      type: "menu",
    },
  },
  /*------------------------------------------------------------------------------------------------*/
];
export default routes;
